import { createApi } from "@reduxjs/toolkit/query/react";
import { toast } from "react-toastify";
import { baseQueryHr } from "./baseQuery";
import { API } from "./constant";

export const hrApi = createApi({
  baseQuery: baseQueryHr,
  reducerPath: "hrApi",
  tagTypes: [
    "ratings",
    "scroreRecommendation",
    "performanceLabel",
    "counsellingType",
    "appraisalPeriod",
    "appraisalObjective",
    "kra",
    "pip",
    "committe",
    "managementAppraisal",
  ],
  endpoints: (builder) => ({
    hrPost: builder.mutation({
      query: (req) => ({
        url: req.path,
        method: "POST",
        body: req.datas,
      }),
      transformErrorResponse: (err) => {
        if (err.status === "FETCH_ERROR") {
          toast.error("Network Error");
        }

        if (err.status === 404 && !err?.data?.statusMessage) {
          toast.error("invalid API", "error");
        } else if (err.status === 500) {
          toast.error(
            "Something went wrong. It’s not you, it’s us. Please give it another try.",
            "error"
          );
        } else if (err.status === 401) {
          toast.error("session has expired login, please login to continue ");
          localStorage.removeItem("token");
          window.location.replace("/");
        }
        return err;
      },
    }),
    hrGet: builder.query({
      query: (queries) => queries,
      transformErrorResponse: (err) => {
        if (err.status === "FETCH_ERROR") {
          toast.error("Network Error");
        } else if (err.status === 500) {
          toast.error(
            "Something went wrong. It’s not you, it’s us. Please give it another try."
          );
        } else if (err.status === 401) {
          toast.error("session has expired login, please login to continue ");
          localStorage.removeItem("token");
          window.location.replace("/");
        }
        return err;
      },
    }),
    hrCreateRatings: builder.mutation({
      query: (req) => ({
        url: API.HR.CREATE_RATING_SCALE,
        method: "POST",
        body: req,
      }),
      invalidatesTags: ["ratings"],
    }),
    getRatings: builder.query({
      query: ({
        PageNumber,
        GeneralSearch,
        PageSize,
        StartDate,
        EndDate,
        ApprovalStatus,
      }) => ({
        url: `${API.HR.GET_RATING_SCALE}?GeneralSearch=${GeneralSearch}&PageSize=${PageSize}&PageNumber=${PageNumber}&StartDate=${StartDate}&EndDate=${EndDate}&ApprovalStatus=${ApprovalStatus}`,
        method: "GET",
      }),
      providesTags: ["ratings"],
    }),

    getAllJobTitle: builder.query({
      query: ({
        PageNumber,
        PageSize,
        StartDate,
        EndDate,
        ApprovalStatus,
        JobRoleId,
      }) => ({
        url: `${
          API.HR.GET_ALL_JOB_TITLE
        }?PageSize=${PageSize}&JobRoleId=${JobRoleId}&PageNumber=${PageNumber}&StartDate=${
          StartDate || ""
        }&EndDate=${EndDate || ""}&ApprovalStatusEnum=${ApprovalStatus || ""}`,
        method: "GET",
      }),
      providesTags: ["getAllJobTitles"],
    }),
    getSingleRating: builder.query({
      query: (id) => ({
        url: `${API.HR.GET_SINGLE_RATING_SCALE}${id}`,
        method: "GET",
      }),
    }),
    editRatingScale: builder.mutation({
      query: (req) => ({
        url: `${API.HR.Edit_RATING_SCALE}`,
        method: "POST",
        body: req,
      }),
      invalidatesTags: ["ratings"],
    }),
    approveDeclineRatingScale: builder.mutation({
      query: (req) => ({
        url: `${API.HR.APPROVE_DECLINE_RATING_SCALE}`,
        method: "POST",
        body: req,
      }),
      invalidatesTags: ["ratings"],
    }),
    deleteRatingScale: builder.mutation({
      query: (id) => ({
        url: `${API.HR.DELETE_RATING_SCALE}`,
        method: "POST",
        body: { id },
      }),
      invalidatesTags: ["ratings"],
    }),
    getScoreRecommwndation: builder.query({
      query: ({
        PageSize,
        PageNumber,
        GeneralSearch,
        StartDate,
        EndDate,
        ApprovalStatus,
      }) => ({
        url: `${API.HR.GET_SCORE_RECOMMENDATION}?GeneralSearch=${GeneralSearch}&PageSize=${PageSize}&PageNumber=${PageNumber}&StartDate=${StartDate}&EndDate=${EndDate}&ApprovalStatus=${ApprovalStatus}`,
      }),
      providesTags: ["scroreRecommendation"],
    }),
    getHODScoreRecommwndation: builder.query({
      query: ({ PageSize, PageNumber, ApprovalStatus }) => ({
        url: `${API.HR.GET_SCORE_RECOMMENDATION}?PageSize=${PageSize}&PageNumber=${PageNumber}&ApprovalStatus=${ApprovalStatus}`,
      }),
      providesTags: ["scroreRecommendation"],
    }),
    getListScoreRecommwndation: builder.query({
      query: ({ PageSize, PageNumber, ApprovalStatus }) => ({
        url: `${
          API.HR.GET_SCORE_RECOMMENDATION
        }?PageSize=${PageSize}&PageNumber=${PageNumber}&ApprovalStatus=${
          ApprovalStatus || ""
        }`,
      }),
      providesTags: ["scroreRecommendation"],
    }),
    createPerformanceLabel: builder.mutation({
      query: (payload) => ({
        method: "POST",
        url: API.HR.CREATE_PERFORMANCE_LABEL,
        body: payload,
      }),
      invalidatesTags: ["performanceLabel"],
    }),
    getPerformanceLabel: builder.query({
      query: ({
        GeneralSearch,
        PageNumber,
        PageSize,
        StartDate,
        EndDate,
        ApprovalStatus,
      }) => ({
        url: `${API.HR.GET_PERFORMANCElABEL}?GeneralSearch=${GeneralSearch}&PageSize=${PageSize}&PageNumber=${PageNumber}&StartDate=${StartDate}&EndDate=${EndDate}&ApprovalStatus=${ApprovalStatus}`,
      }),
      providesTags: ["performanceLabel"],
    }),
    getSingleStatusLabel: builder.query({
      query: (id) => ({
        url: `${API.HR.GET_SINGLE_ERFORMANCE_LABEL}?Id=${id}`,
      }),
      providesTags: ["performanceLabel"],
    }),
    approveDeclineStatusLabel: builder.mutation({
      query: (req) => ({
        method: "POST",
        body: req,
        url: API.HR.APPROVE_DECLINE_STATUS_LABEL,
      }),
      invalidatesTags: ["performanceLabel"],
    }),
    deleteStatusLabel: builder.mutation({
      query: (payload) => ({
        method: "POST",
        url: API.HR.DELETE_STATUS_LABEL,
        body: payload,
      }),
      invalidatesTags: ["performanceLabel"],
    }),
    updateSetatusLabel: builder.mutation({
      query: (req) => ({
        method: "POST",
        body: req,
        url: API.HR.EDIT_STATUS_LABEL,
      }),
      invalidatesTags: ["performanceLabel"],
    }),
    getCounsellingType: builder.query({
      query: ({
        GeneralSearch,
        PageNumber,
        PageSize,
        StartDate,
        EndDate,
        ApprovalStatus,
      }) => ({
        url: `${API.HR.COUNSELLING_TYPE}?GeneralSearch=${GeneralSearch}&PageSize=${PageSize}&PageNumber=${PageNumber}&StartDate=${StartDate}&EndDate=${EndDate}&ApprovalStatus=${ApprovalStatus}`,
      }),
      providesTags: ["counsellingType"],
    }),
    getCounsellingTypeList: builder.query({
      query: ({
        PageNumber,
        PageSize,

        ApprovalStatus,
      }) => ({
        url: `${API.HR.COUNSELLING_TYPE}?PageSize=${PageSize}&PageNumber=${PageNumber}&ApprovalStatus=${ApprovalStatus}`,
      }),
      providesTags: ["counsellingType"],
    }),
    getDevelopmentTypeList: builder.query({
      query: ({
        PageNumber,
        PageSize,
        Search,
        EndDate,
        StartDate,
        ApprovalStatus,
      }) => ({
        url: `${API.HR.Development_TYPE}?PageSize=${PageSize}&ApprovalStatus=${
          ApprovalStatus || ""
        }&EndDate=${EndDate || ""}&StartDate=${
          StartDate || ""
        }&PageNumber=${PageNumber}&Search=${Search}`,
      }),
      providesTags: ["developmentType"],
    }),
    getExpectedImprovementPlan: builder.query({
      query: ({
        PageNumber,
        PageSize,
        Search,
        EndDate,
        StartDate,
        ApprovalStatus,
      }) => ({
        url: `${
          API.HR.EXPECTED_IMPROVEMENT_PAN
        }?PageSize=${PageSize}&ApprovalStatus=${ApprovalStatus || ""}&EndDate=${
          EndDate || ""
        }&StartDate=${
          StartDate || ""
        }&PageNumber=${PageNumber}&Search=${Search}`,
      }),
      providesTags: ["expectedImprovementPlan"],
    }),
    getAllCounsellingType: builder.query({
      query: () => ({
        url: `${API.HR.COUNSELLING_TYPE}`,
      }),
      providesTags: ["counsellingType"],
    }),
    createCounsellingType: builder.mutation({
      query: (req) => ({
        method: "POST",
        body: req,
        url: API.HR.CREATE_COUNSELLING_TYPE,
      }),
      invalidatesTags: ["counsellingType"],
    }),
    createDevelopmentType: builder.mutation({
      query: (req) => ({
        method: "POST",
        body: req,
        url: API.HR.CREATE_DEVELOPMENT_TYPE,
      }),
      invalidatesTags: ["developmentType"],
    }),
    createExpectedImprovementPlan: builder.mutation({
      query: (req) => ({
        method: "POST",
        body: req,
        url: API.HR.CREATE_IMPROVEMENT_PLAN,
      }),
      invalidatesTags: ["expectedImprovementPlan"],
    }),
    approveDeclineCounsellingType: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.COUNSELLING_TYPE_APPROVE_DECLINE,
        body: req,
      }),
      invalidatesTags: ["counsellingType"],
    }),
    approveDeclineDevelopmentPlan: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.DEVELOPMENT_APPROVE_DECLINE,
        body: req,
      }),
      invalidatesTags: ["developmentPlan"],
    }),
    approveDeclineImprovementPerformance: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.IMPROVEMENT_PERFORMANCE_APPROVE_DECLINE,
        body: req,
      }),
      invalidatesTags: ["expectedImprovementPlan"],
    }),
    singelCounsellingType: builder.query({
      query: (id) => ({
        url: `${API.HR.SINGLE_CONSELLING_TYPE}?Id=${id}`,
      }),
      providesTags: ["counsellingType"],
    }),
    singelDevelopmentPlan: builder.query({
      query: (id) => ({
        url: `${API.HR.SINGLE_DEVELOPMENT_PLAN}?Id=${id}`,
      }),
      providesTags: ["developmentPlan"],
    }),
    singelImprovementPlan: builder.query({
      query: (id) => ({
        url: `${API.HR.SINGLE_EXPECTED_IMPROVEMENT_PAN}?Id=${id}`,
      }),
      providesTags: ["expectedImprovementPlan"],
    }),
    editCounsellingType: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.EDIT_COUNSELLING_TYPE,
        body: req,
      }),
      invalidatesTags: ["counsellingType"],
    }),
    editDevelopmentType: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.EDIT_DEVELOPMENT_PLAN,
        body: req,
      }),
      invalidatesTags: ["developmentType"],
    }),
    editExpectedImprovementPlan: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.EDIT_IMPROVEMENT_PLAN,
        body: req,
      }),
      invalidatesTags: ["expectedImprovementPlan"],
    }),
    deleteCounsellingType: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.DELETE_COUNSELLING_TYPE,
        body: req,
      }),
      invalidatesTags: ["counsellingType"],
    }),
    deleteDevelpmentPlan: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.DELETE_DEVELOPMENT_PLAN,
        body: req,
      }),
      invalidatesTags: ["developmentPlan"],
    }),
    deleteExpectedImprovementPlan: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.DELETE_EXPECTED_IMPROVEMENT_PLAN,
        body: req,
      }),
      invalidatesTags: ["expectedImprovementPlan"],
    }),
    createScoreRecommendation: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.CREATE_SCORE_RECOMMENDATION,
        body: req,
      }),
      invalidatesTags: ["scroreRecommendation"],
    }),
    deleteScoreBasedRecommendation: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.DELETE_SCORE_BASED_RECOMMENDATION,
        body: req,
      }),
      invalidatesTags: ["scroreRecommendation"],
    }),
    singleScoreBasedRecommendation: builder.query({
      query: (id) => ({
        url: `${API.HR.SING_SCORE_BASED_RECOMMENDATION}?Id=${id}`,
      }),
      providesTags: ["scroreRecommendation"],
    }),
    approveDeclineScoreBasedRecommendation: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.APPROVE_DECLINE_SCORE_BASED_RECOMMENDATION,
        body: req,
      }),
      invalidatesTags: ["scroreRecommendation"],
    }),
    approveDeclinePIP: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.APPROVE_DECLINE_PIP,
        body: req,
      }),
      invalidatesTags: ["pip"],
    }),
    updateScoreBasedRecommendation: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.UPDATE_SCORE_BASED_RECOMMENDATION,
        body: req,
      }),
      invalidatesTags: ["scroreRecommendation"],
    }),
    getAppraisalPeriod: builder.query({
      query: ({
        PageSize = 10,
        PageNumber = 1,
        ApprovalStatus,
        year = "",
        GeneralSearch = "",
      }) => ({
        url: `${API.HR.GET_APPRAISAL_PERIOD}?GeneralSearch=${GeneralSearch}&PageSize=${PageSize}&PageNumber=${PageNumber}&ApprovalStatus=${ApprovalStatus}&year=${year}`,
      }),
      providesTags: ["appraisalPeriod"],
    }),
    getAppraisalPeriodSelect: builder.query({
      query: ({
        PageSize = 1000,
        PageNumber = 1,
        ApprovalStatus = 0,
        year = "",
        GeneralSearch = "",
      }) => ({
        url: `${API.HR.GET_APPRAISAL_PERIOD}?GeneralSearch=${GeneralSearch}&PageSize=${PageSize}&PageNumber=${PageNumber}&ApprovalStatus=${ApprovalStatus}&year=${year}`,
      }),
      providesTags: ["appraisalPeriod"],
    }),
    getAppraisalObjectives: builder.query({
      query: ({
        ApprovalStatus,
        departmentId = null,
        PageSize,
        PageNumber,
      }) => ({
        url: `${API.HR.GET_APPRAISAL_OBJECTIVES}?ApprovalStatus=${ApprovalStatus}&departmentId=${departmentId}&PageSize=${PageSize}&PageNumber=${PageNumber}`,
      }),
      providesTags: ["appraisalObjective"],
    }),
    createAppraisalPeriod: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.CREATE_APPRAISAL_PERIOD,
        body: req,
      }),
      invalidatesTags: ["appraisalPeriod"],
    }),
    approveDeclineAppraisalPeriod: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.APPROVE_DECLINE_APPRAISAL_PERIOD,
        body: req,
      }),
      invalidatesTags: ["appraisalPeriod"],
    }),
    deletAppraisalPeriod: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.DELETE_APPRAISAL_PERIOD,
        body: req,
      }),
      invalidatesTags: ["appraisalPeriod"],
    }),
    getSingleAppraisal: builder.query({
      query: (id) => ({
        url: `${API.HR.GET_SINGLE_APPRAISAL_PERIOD}?Id=${id}`,
      }),
      providesTags: ["appraisalPeriod"],
    }),
    updateAppraisalPeriod: builder.mutation({
      query: (req) => ({
        method: "POST",
        body: req,
        url: API.HR.UPDATE_APPRAISAL_PERIOD,
      }),
      invalidatesTags: ["appraisalPeriod"],
    }),
    getAppraisalObjectiveMain: builder.query({
      query: ({
        GeneralSearch,
        PageSize,
        PageNumber,
        ApprovalStatus,
        StartDate,
        EndDate,
        year,
        DepartmentId,
        JobRoleId,
      }) => ({
        url: `${API.HR.GET_APPRAISAL_OBJECTIVES}?JobRoleId=${
          JobRoleId || ""
        }&DepartmentId=${DepartmentId || ""}&GeneralSearch=${
          GeneralSearch || ""
        }&PageSize=${PageSize || 1}&PageNumber=${
          PageNumber || 1
        }&ApprovalStatus=${ApprovalStatus || ""}&StartDate=${
          StartDate || ""
        }&EndDate=${EndDate || ""}&year=${year || ""}`,
      }),
      providesTags: ["appraisalObjective"],
    }),
    createAppraisalObjective: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.CREATE_APPRAISAL_OBJECTIVE,
        body: req,
      }),
      invalidatesTags: ["appraisalObjective"],
    }),
    updateAppraisalObjective: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.UPDATE_APPRAISAL_OBJECTIVE,
        body: req,
      }),
      invalidatesTags: ["appraisalObjective"],
    }),
    deleteAppraisalObjective: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.DELETE_APPRAISAL_OBJECTIVE,
        body: req,
      }),
      invalidatesTags: ["appraisalObjective"],
    }),
    getSingleAppraisalObjective: builder.query({
      query: (id) => ({
        url: `${API.HR.GET_SINGLE_APPRAISAL_OBJECTIVE}?Id=${id}`,
      }),
      providesTags: ["appraisalObjective"],
    }),
    approveDeclineObjective: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.APPROVE_DECLINE_OBJECTIVE,
        body: req,
      }),
      invalidatesTags: ["appraisalObjective"],
    }),
    getKRA: builder.query({
      query: ({
        Search,
        PageSize,
        PageNumber,
        AppraisalPeriod,
        ApprovalStatus,
        StartDate,
        EndDate,
        Type,
        ObjectiveId,
      }) => {
        let urLwithoutAppraisalPeriod = `${API.HR.GET_KRA_ALL}?TitleKeyword=${Search}&PageSize=${PageSize}&PageNumber=${PageNumber}&ApprovalStatus=${ApprovalStatus}&PeriodStartDateFrom=${StartDate}&PeriodStartDateFrom=${EndDate}&Type=${Type}&ObjectiveId=${ObjectiveId}`;
        if (AppraisalPeriod) {
          urLwithoutAppraisalPeriod += `&AppraisalPeriod=${AppraisalPeriod}`;
        }
        return {
          url: urLwithoutAppraisalPeriod,
        };
      },
      providesTags: ["kra"],
    }),
    getKRAForObjectives: builder.query({
      query: ({ PageSize, PageNumber, ObjectiveId }) => ({
        url: `${API.HR.GET_KRA_ALL}?PageSize=${PageSize}&PageNumber=${PageNumber}&ObjectiveId
=${ObjectiveId}`,
      }),
      providesTags: ["kra"],
    }),
    getListKRA: builder.query({
      query: ({ ApprovalStatus }) => ({
        url: `${API.HR.GET_KRA_ALL}?ApprovalStatus=${ApprovalStatus}`,
      }),
      providesTags: ["kra"],
    }),
    getKRATitles: builder.query({
      query: () => ({
        url: `KeyResultArea/All?ApprovalStatus=0&PageSize=1000&PageNumber=1`,
      }),
      providesTags: ["kra"],
    }),
    getHrContainer: builder.query({
      query: () => ({
        url: "/Container/AllContainer",
      }),
    }),
    getHrDepartments: builder.query({
      query: () => ({
        url: "/Department/AllDepartment?PageSize=1000&PageNumber=1",
      }),
    }),
    getEmployeeByContainerId: builder.query({
      query: (id) => ({
        url: `Employee/GetAllEmployeesByContainerId?ContainerId=${id}&PageSize=1000&PageNumber=1`,
      }),
    }),
    createKRA: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.CREATE_KRA,
        body: req,
      }),
      invalidatesTags: ["kra"],
    }),
    getRatingsSelect: builder.query({
      query: ({ ApprovalStatus }) => ({
        url: `${API.HR.GET_RATING_SCALE}?ApprovalStatus=${ApprovalStatus}`,
        method: "GET",
      }),
      providesTags: ["ratings"],
    }),
    getSingleKeyResultArea: builder.query({
      query: (id) => ({
        url: `${API.HR.VIEW_SINGLE_KEY_RESULT_AREA}?Id=${id}`,
      }),
      providesTags: ["kra"],
    }),
    getSingleKeyResultAreaById: builder.query({
      query: (id) => ({
        url: `${API.HR.KeyResultArea_By_ID}?Id=${id}`,
      }),
      providesTags: ["kra"],
    }),
    approveDeclineKRA: builder.mutation({
      query: (req) => ({
        url: API.HR.APPROVE_DECLINE_KRA,
        method: "POST",
        body: req,
      }),
      invalidatesTags: ["kra"],
    }),
    deleteKRA: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.DELETE_KRA,
        body: req,
      }),
      invalidatesTags: ["kra"],
    }),
    updateKRA: builder.mutation({
      query: (req) => ({
        url: API.HR.UPDATE_KRA,
        method: "POST",
        body: req,
      }),
      invalidatesTags: ["kra"],
    }),
    getPIP: builder.query({
      query: ({
        EvaluationStatus,
        AppraisalPeriod,
        PageNumber,
        PageSize,
        AppraiserId,
        StartDate,
        EndDate,
        GeneralSearch,
        Status,
      }) => ({
        url: `${API.HR.GET_PIP}?AppraisalPeriod=${
          AppraisalPeriod || ""
        }&AppraiserId=${AppraiserId}&EvaluationStatus=${
          EvaluationStatus || ""
        }&PageNumber=${PageNumber}&PageSize=${PageSize}&StartDate=${StartDate}&EndDate=${EndDate}&GeneralSearch=${GeneralSearch}&Status=${
          Status || ""
        }`,
      }),
      providesTags: ["pip"],
    }),
    getHODAppraisal: builder.query({
      query: ({
        PageNumber,
        PageSize,
        HODId,
        StartDate,
        EndDate,
        SearchTerm,
        Status,
        ObjectiveId,
        PeriodStartDate,
        PeriodEndDate,
      }) => ({
        url: `${
          API.HR.GET_HOD_REVIEWS
        }?HODId=${HODId}&PageNumber=${PageNumber}&PageSize=${PageSize}&StartDate=${StartDate}&EndDate=${EndDate}&SearchTerm=${SearchTerm}&AppraisalWorkflowStatus=${
          Status || ""
        }&ObjectiveId=${ObjectiveId || ""}&PeriodStartDate=${
          PeriodStartDate || ""
        }&PeriodEndDate=${PeriodEndDate || ""}`,
      }),
    }),
    getManagementAppraisal: builder.query({
      query: ({
        PageNumber,
        PageSize,
        ReviewerRole,
        StartDate,
        EndDate,
        SearchTerm,
        Status,
        ObjectiveId,
        DepartmentId,
        PeriodStartDate,
        PeriodEndDate,
        date,
        recommendation,
      }) => ({
        url: `${
          API.HR.GET_EXCECUTIVE_REVIEWS
        }?ReviewerRole=${ReviewerRole || ''}&PageNumber=${PageNumber}&PageSize=${PageSize}&StartDate=${StartDate}&EndDate=${EndDate}&SearchTerm=${SearchTerm}&AppraisalWorkflowStatus=${
          Status || ""
        }&ObjectiveId=${ObjectiveId || ""}&DepartmentId=${
          DepartmentId || ""
        }&PeriodStartDate=${PeriodStartDate || ""}&PeriodEndDate=${
          PeriodEndDate || ""
        }&Year=${date || ""}&Recommendation=${recommendation || ""}`,
      }),
      providesTags: ["managementAppraisal"],
    }),
    getSingleMainPIP: builder.query({
      query: (id) => ({
        url: `${API.HR.GET_SINGLE_MAIN_PIP}?Id=${id}`,
      }),
      providesTags: ["pip"],
    }),
    createPIP: builder.mutation({
      query: (req) => ({
        url: API.HR.CREATE_PIP,
        method: "POST",
        body: req,
      }),
      invalidatesTags: ["pip"],
    }),
    getSinglePIP: builder.query({
      query: (id) => ({
        url: `${API.HR.GET_SINGLE_PIP}?Id=${id}`,
      }),
      providesTags: ["pip"],
    }),
    getTrainingType: builder.query({
      query: ({ Category, PageSize, PageNumber }) => ({
        url: `${API.HR.GET_TRAINING_TYPE}?Category=${Category}&PageSize=${PageSize}&PageNumber=${PageNumber}`,
      }),
    }),
    getTrainingRequisition: builder.query({
      query: ({ TraniningTypeId, PageSize, PageNumber, ApprovalStatus }) => ({
        url: `${API.HR.GET_TRAINING_REQUISITION}?TraniningTypeId=${TraniningTypeId}&PageSize=${PageSize}&PageNumber=${PageNumber}&ApprovalStatus=${ApprovalStatus}`,
      }),
    }),
    HODAppraisalReview: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.HOD_APPRAISAL_REVIEW,
        body: req,
      }),
    }),
    excecutiveAppraisalReview: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.EXCECUTIVE_APPRAISAL,
        body: req,
      }),
    }),
    getJobRole: builder.query({
      query: ({
        ApprovalStatus,
        departmentId,
        PageSize = 1000,
        PageNumber = 1,
      }) => ({
        url: `${
          API.HR.GET_JOB_ROLE
        }?ApprovalStatus=${ApprovalStatus}&departmentId=${
          departmentId || ""
        }&pageSize=${PageSize}&pageNumber=${PageNumber}`,
      }),
    }),
    getJobRoleById: builder.query({
      query: (id) => ({
        url: `${API.HR.GET_DESIGNATION_BY_ID}?id=${id}`,
      }),
    }),
    managementAppraisalReview: builder.mutation({
      query: (req) => ({
        method: "POST",
        url: API.HR.MANAGEMENT_APPRAISAL_REVIEW,
        body: req,
      }),
    }),
    getSingleEmployee: builder.query({
      query: (id) => ({
        url: `${API.HR.GET_ONE_EMPLOYEEE_BY_ID}?id=${id}`,
      }),
    }),
    createCommitte: builder.mutation({
      query: (req) => ({
        url: API.HR.CREATE_COMMITTEE,
        body: req,
        method: "POST",
      }),
      invalidatesTags: ["committe"],
    }),
    updateCommittee: builder.mutation({
      query: ({ body, id }) => ({
        url: `${API.HR.UPDATE_COMMITTEE}/${id}`,
        body: body,
        method: "POST",
      }),
      invalidatesTags: ["committe"],
    }),
    getCommitte: builder.query({
      query: ({
        searchTerm,
        status,
        createdDateFrom,
        createdDateTo,
        includeInactive,
        pageSize,
        pageNumber,
      }) => ({
        url: `${API.HR.CREATE_COMMITTEE}?searchTerm=${searchTerm}&status=${status}&createdDateFrom=${createdDateFrom}&createdDateTo=${createdDateTo}&includeInactive=${includeInactive}&pageSize=${pageSize}&pageNumber=${pageNumber}`,
      }),
      providesTags: ["committe"],
    }),
    deleteCommitte: builder.mutation({
      query: ({ id }) => ({
        url: `${API.HR.DELETE_COMMITTEE}/${id}`,
        method: "POST",
      }),
      invalidatesTags: ["committe"],
    }),
    getSingleCommitte: builder.query({
      query: (id) => ({
        url: `${API.HR.CREATE_COMMITTEE}/${id}`,
      }),
      providesTags: ["committe"],
    }),
    approveDeclineCommittee: builder.mutation({
      query: ({ committeeId, decision, comments, id }) => ({
        url: `${API.HR.APPROVE_DECLINE_COMMITTEE}/${id}/approve`,
        method: "POST",
        body: { committeeId, decision, comments },
      }),
    }),
    managementComment: builder.mutation({
      query: (req) => ({
        url: API.HR.MGT_COMMENTS,
        method: "POST",
        body: req,
      }),
      invalidatesTags: ["managementAppraisal"],
    }),
    getRetentionMetrics: builder.query({
      query: ({year}) => ({
        url: `${API.HR.GET_RETENTION_METRICS}?year=${year}`,
      }),
    }),
  }),
});

export const {
  useHrGetQuery,
  useHrPostMutation,
  useHrCreateRatingsMutation,
  useGetRatingsQuery,
  useGetSingleRatingQuery,
  useEditRatingScaleMutation,
  useGetSingleKeyResultAreaByIdQuery,
  useApproveDeclineRatingScaleMutation,
  useDeleteRatingScaleMutation,
  useGetScoreRecommwndationQuery,
  useCreatePerformanceLabelMutation,
  useGetPerformanceLabelQuery,
  useGetSingleStatusLabelQuery,
  useApproveDeclineStatusLabelMutation,
  useDeleteStatusLabelMutation,
  useUpdateSetatusLabelMutation,
  useGetCounsellingTypeQuery,
  useCreateCounsellingTypeMutation,
  useApproveDeclineDevelopmentPlanMutation,
  useApproveDeclineImprovementPerformanceMutation,
  useApproveDeclineCounsellingTypeMutation,
  useSingelCounsellingTypeQuery,
  useEditCounsellingTypeMutation,
  useDeleteCounsellingTypeMutation,
  useCreateScoreRecommendationMutation,
  useDeleteScoreBasedRecommendationMutation,
  useSingleScoreBasedRecommendationQuery,
  useApproveDeclineScoreBasedRecommendationMutation,
  useUpdateScoreBasedRecommendationMutation,
  useGetAppraisalPeriodQuery,
  useGetAppraisalObjectivesQuery,
  useCreateAppraisalPeriodMutation,
  useApproveDeclineAppraisalPeriodMutation,
  useDeletAppraisalPeriodMutation,
  useGetSingleAppraisalQuery,
  useUpdateAppraisalPeriodMutation,
  useGetAppraisalObjectiveMainQuery,
  useCreateAppraisalObjectiveMutation,
  useDeleteAppraisalObjectiveMutation,
  useGetSingleAppraisalObjectiveQuery,
  useApproveDeclineObjectiveMutation,
  useGetKRAQuery,
  useGetHrContainerQuery,
  useGetHrDepartmentsQuery,
  useCreateKRAMutation,
  useGetAppraisalPeriodSelectQuery,
  useGetRatingsSelectQuery,
  useGetSingleKeyResultAreaQuery,
  useApproveDeclineKRAMutation,
  useDeleteKRAMutation,
  useUpdateKRAMutation,
  useCreatePIPMutation,
  useGetPIPQuery,
  useGetSinglePIPQuery,
  useGetAllCounsellingTypeQuery,
  useGetTrainingTypeQuery,
  useGetTrainingRequisitionQuery,
  useHODAppraisalReviewMutation,
  useGetJobRoleQuery,
  useGetJobRoleByIdQuery,
  useGetListKRAQuery,
  useGetKRATitlesQuery,
  useManagementAppraisalReviewMutation,
  useUpdateAppraisalObjectiveMutation,
  useGetListScoreRecommwndationQuery,
  useGetEmployeeByContainerIdQuery,
  useGetSingleEmployeeQuery,
  useCreateCommitteMutation,
  useGetCommitteQuery,
  useDeleteCommitteMutation,
  useGetSingleCommitteQuery,
  useApproveDeclineCommitteeMutation,
  useUpdateCommitteeMutation,
  useGetCounsellingTypeListQuery,
  useApproveDeclinePIPMutation,
  useGetSingleMainPIPQuery,
  useGetDevelopmentTypeListQuery,
  useGetExpectedImprovementPlanQuery,
  useGetKRAForObjectivesQuery,
  useCreateDevelopmentTypeMutation,
  useDeleteDevelpmentPlanMutation,
  useGetHODScoreRecommwndationQuery,
  useEditDevelopmentTypeMutation,
  useSingelImprovementPlanQuery,
  useDeleteExpectedImprovementPlanMutation,
  useSingelDevelopmentPlanQuery,
  useCreateExpectedImprovementPlanMutation,
  useEditExpectedImprovementPlanMutation,
  useGetHODAppraisalQuery,
  useGetManagementAppraisalQuery,
  useExcecutiveAppraisalReviewMutation,
  useGetAllJobTitleQuery,
  useManagementCommentMutation,
  useGetRetentionMetricsQuery,
} = hrApi;
